// test1999
(1999 && 0);
